import React from "react";
import { useParams, Link, useLocation } from "react-router-dom";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import EventSettings from "./EventSettings";
import EventRegistrations from "./EventRegistrations";

const EventDetail: React.FC = () => {
  const { eventId } = useParams<{ eventId: string }>();
  const location = useLocation();
  
  // Determine active tab from URL hash or default to settings
  const hash = location.hash.replace("#", "");
  const activeTab = hash === "registrations" ? "registrations" : "settings";

  // Get event name (for now we only have one event)
  const eventName = "Build With Christ - March 2026";

  return (
    <div className="p-8 space-y-6">
      <div className="flex items-center gap-4">
        <Link to="/admin/events">
          <Button variant="ghost" size="sm" className="gap-2">
            <ArrowLeft className="h-4 w-4" />
            Back to Events
          </Button>
        </Link>
      </div>

      <div>
        <h1 className="text-2xl font-bold font-display">{eventName}</h1>
        <p className="text-muted-foreground">March 7, 2026 • Phase Events, Alpharetta, GA</p>
      </div>

      <Tabs defaultValue={activeTab} className="space-y-6">
        <TabsList>
          <TabsTrigger value="settings" asChild>
            <Link to={`/admin/events/${eventId}#settings`} className="data-[state=active]:bg-background">
              Settings
            </Link>
          </TabsTrigger>
          <TabsTrigger value="registrations" asChild>
            <Link to={`/admin/events/${eventId}#registrations`} className="data-[state=active]:bg-background">
              Registrations
            </Link>
          </TabsTrigger>
        </TabsList>

        <TabsContent value="settings" className="mt-0">
          <EventSettings embedded />
        </TabsContent>

        <TabsContent value="registrations" className="mt-0">
          <EventRegistrations embedded />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default EventDetail;
